import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Tabs,
  Tab,
  ButtonToolbar,
  Modal,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import {
  getValueType,
  iconError,
  showConfirmDialog,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  validatePost,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import { makeStyles, fade } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  fetchParameter,
  fetchParameter2,
  fetchParameter3,
  fetchParameter4,
  fetchParameter5,
  selectParameter,
  selectParameter2,
  selectParameter3,
  selectParameter4,
  selectParameter5,
} from "../businessParameter/businessParameterSlice";
import {
  FormControlLabel,
  FormHelperText,
  MenuItem,
  Radio,
  RadioGroup,
  ThemeProvider,
  createMuiTheme,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

import {
  selectIdLocation,
  selectLoading,
  fetchIdLocation,
  addLocation,
  editLocation,
} from "./locationManagementSlice";
import { ModalProductSelect } from "./ModalProductSelect";
import { ModalModelSelect } from "./ModalModelSelect";
import { ModalColorSelect, ModalcolorSelect } from "./ModalColorSelect";
import {
  fetchMstareatype,
  selectMstareatype,
} from "../motorPool/motorPoolSlice";
import { selectMstaddresstype } from "../location/locationSlice";
import { ModalParentSelect } from "./ModalParentSelect";
import { ModalAreaSelect } from "./ModalAreaSelect";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
  focused: {},
}));

const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: "#db3131",
        "&$error": {
          color: "#db3131",
        },
      },
    },
    MuiFormHelperText: {
      root: {
        margin: "1px !important", // Remove the margin
      },
    },
  },
  typography: {
    fontFamily: `"Poppins", "Helvetica", "Arial", sans-serif`,
  },
});
function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const MotorPoolAreaEdit = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectIdLocation);
  const { id } = useParams();
  const dataDistance = useSelector(selectParameter);
  const dataWeight = useSelector(selectParameter2);
  const dataUom = useSelector(selectParameter3);
  const dataVolume = useSelector(selectParameter4);
  const dataAreaType = useSelector(selectMstareatype);
  const dataValidated = useSelector(selectParameter5);

  const [getDataProduct, setGetDataProduct] = useState(false);
  const [getDataColor, setGetDataColor] = useState(false);
  const [getDataModel, setGetDataModel] = useState(false);

  // initial

  const [formValues, setFormValues] = useState({
    location_name: {
      value: "",
      error: false,
      required: "Y",
    },
    motorpool_area: {
      value: "",
      error: false,
      required: "N",
    },
    motorpool_area_name: {
      value: "",
      error: false,
      required: "N",
    },
    parent_area: {
      value: "",
      error: false,
      required: "Y",
    },
    parent_area_name: {
      value: "",
      error: false,
      required: "N",
    },
    area_type: {
      value: "",
      error: false,
      required: "N",
    },
    area_type_name: {
      value: "",
      error: false,
      required: "N",
    },
    product_id: {
      value: "",
      error: false,
      required: "N",
    },
    product_name: {
      value: "",
      error: false,
      required: "N",
    },
    model_id: {
      value: "",
      error: false,
      required: "N",
    },
    model_name: {
      value: "",
      error: false,
      required: "N",
    },
    color_id: {
      value: "",
      error: false,
      required: "N",
    },
    color_name: {
      value: "",
      error: false,
      required: "N",
    },
    x: {
      value: "",
      error: false,
      required: "N",
    },
    y: {
      value: "",
      error: false,
      required: "N",
    },
    z: {
      value: "",
      error: false,
      required: "N",
    },
    posision_distance: {
      value: "",
      error: false,
      required: "N",
    },
    l: {
      value: "",
      error: false,
      required: "N",
    },
    w: {
      value: "",
      error: false,
      required: "N",
    },
    h: {
      value: "",
      error: false,
      required: "N",
    },
    dimension_distance: {
      value: "",
      error: false,
      required: "N",
    },
    max_weight: {
      value: "",
      error: false,
      required: "N",
    },
    max_weight_type: {
      value: "",
      error: false,
      required: "N",
    },
    max_qty: {
      value: "",
      error: false,
      required: "N",
    },
    max_qty_type: {
      value: "",
      error: false,
      required: "N",
    },
    max_volume: {
      value: "",
      error: false,
      required: "N",
    },
    max_volume_type: {
      value: "",
      error: false,
      required: "N",
    },
    validate: {
      value: "",
      error: false,
      required: "N",
    },
    is_enable: {
      value: "",
      error: false,
      required: "N",
    },
  });

  const [formArea, setFormArea] = useState({
    name: {
      value: "",
      error: false,
      required: "Y",
    },
    area_type: {
      value: "",
      error: false,
      required: "N",
    },
    area_type_name: {
      value: "",
      error: false,
      required: "N",
    },
  });

  useEffect(() => {
    async function fetchMyAPI() {
      await callApi(id);
      await dispatch(
        fetchMstareatype({
          is_enable: "Y",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter({
          paramgroup_code: "DISTANCE_MEASUREMENT",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter2({
          paramgroup_code: "WEIGTH_MEASUREMENT",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter3({
          paramgroup_code: "BASE_UOM",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter4({
          paramgroup_code: "VOLUME_MEASUREMENT",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter5({
          paramgroup_code: "VALIDATED_TYPE",
          pageNo: 1,
          pageSize: -1,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch, id]);

  const callApi = async (id) => {
    try {
      const response = await dispatch(fetchIdLocation(id));
      console.log(response, "res");
      if (response.payload.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  useEffect(() => {
    if (dataId !== null) {
      console.log(dataId.area_type_name, "name");
      setFormValues({
        location_name: {
          value: dataId.location_name,
          error: false,
          required: "Y",
        },
        motorpool_area: {
          value: dataId.motor_pool_id,
          error: false,
          required: "N",
        },
        motorpool_area_name: {
          value: dataId.motor_pool_name,
          error: false,
          required: "N",
        },
        parent_area: {
          value: dataId.pid,
          error: false,
          required: "Y",
        },
        parent_area_name: {
          value: dataId.parent_name,
          error: false,
          required: "N",
        },
        area_type: {
          value: dataId.area_type === null ? "" : dataId.area_type,
          error: false,
          required: "N",
        },
        area_type_name: {
          value: dataId.area_type_name === null ? "" : dataId.area_type_name,
          error: false,
          required: "N",
        },
        product_id: {
          value: dataId.storage_product === null ? "" : dataId.storage_product,
          error: false,
          required: "N",
        },
        product_name: {
          value:
            dataId.storage_product_name === null
              ? ""
              : dataId.storage_product_name,
          error: false,
          required: "N",
        },
        model_id: {
          value: dataId.storage_model === null ? "" : dataId.storage_model,

          error: false,
          required: "N",
        },
        model_name: {
          value:
            dataId.storage_model_name === null ? "" : dataId.storage_model_name,

          error: false,
          required: "N",
        },
        color_id: {
          value: dataId.storage_color === null ? "" : dataId.storage_color,

          error: false,
          required: "N",
        },
        color_name: {
          value:
            dataId.storage_color_name === null ? "" : dataId.storage_color_name,
          error: false,
          required: "N",
        },
        x: {
          value: dataId.position_x,
          error: false,
          required: "N",
        },
        y: {
          value: dataId.position_y,
          error: false,
          required: "N",
        },
        z: {
          value: dataId.position_z,
          error: false,
          required: "N",
        },
        posision_distance: {
          value: dataId.position_uom,
          error: false,
          required: "N",
        },
        l: {
          value: dataId.dimension_l,

          error: false,
          required: "N",
        },
        w: {
          value: dataId.dimension_w,

          error: false,
          required: "N",
        },
        h: {
          value: dataId.dimension_h,
          error: false,
          required: "N",
        },
        dimension_distance: {
          value: dataId.dimension_uom,
          error: false,
          required: "N",
        },
        max_weight: {
          value: dataId.capacity_weight,
          error: false,
          required: "N",
        },
        max_weight_type: {
          value: dataId.capacity_weight_type,
          error: false,
          required: "N",
        },
        max_qty: {
          value: dataId.capacity_qty,
          error: false,
          required: "N",
        },
        max_qty_type: {
          value: dataId.capacity_qty_type,
          error: false,
          required: "N",
        },
        max_volume: {
          value: dataId.capacity_volume,
          error: false,
          required: "N",
        },
        max_volume_type: {
          value: dataId.capacity_volume_type,
          error: false,
          required: "N",
        },
        validate: {
          value: dataId.validated_by,
          error: false,
          required: "N",
        },
        is_enable: {
          value: dataId.is_enable,
          error: false,
          required: "N",
        },
      });
    }
  }, [dataId]);

  const handleSave = async () => {
    if (!validatePost(formValues, setFormValues)) {
      return;
    }

    if (
      formValues.location_name.value.includes("<script>") ||
      formValues.location_name.value.includes("</script>")
    ) {
      return showErrorDialog("please don't input value <script>");
    }


    const params = {
      location_id: dataId.location_id,
      location_address: "",
      location_name: formValues.location_name.value,
      // motorpool_area: formValues.motorpool_area.value,
      pid: formValues.parent_area.value,
      area_type: formValues.area_type.value,
      storage_product: formValues.product_id.value,
      storage_model: formValues.model_id.value,
      storage_color: formValues.color_id.value,
      position_x: formValues.x.value,
      position_y: formValues.y.value,
      position_z: formValues.x.value,
      position_uom: formValues.posision_distance.value,
      dimension_l: formValues.l.value,
      dimension_w: formValues.w.value,
      dimension_h: formValues.h.value,
      dimension_uom: formValues.dimension_distance.value,
      capacity_weight: formValues.max_weight.value,
      capacity_weight_type: formValues.max_weight_type.value,
      capacity_qty: formValues.max_qty.value,
      capacity_qty_type: formValues.max_qty_type.value,
      capacity_volume: formValues.max_volume.value,
      capacity_volume_type: formValues.max_volume_type.value,
      validated_by: formValues.validate.value,
      is_enable: formValues.is_enable.value,
    };

    console.log(params, "params");
    try {
      const response = await dispatch(editLocation(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        if (action.isConfirmed) callApi(id);
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  // modal office

  const [showProduct, setShowProduct] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [showColor, setShowColor] = useState(false);
  const [showParent, setShowParent] = useState(false);
  const [showArea, setShowArea] = useState(false);
  const [showAreaChild, setShowAreaChild] = useState(false);

  const [fieldsProduct, setFieldsProduct] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);
  const [fieldsModel, setFieldsModel] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);
  const [fieldsColor, setFieldsColor] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  const [fieldsParent, setFieldsParent] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);
  const [fieldsArea, setFieldsArea] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  // modal Client

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const distanceOptions = dataDistance.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });
  const weightOptions = dataWeight.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });
  const uomOptions = dataUom.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });
  const volumeOptions = dataVolume.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const areaTypeOptions = dataAreaType.map((e) => {
    return {
      value: e.areatype_id,
      label: e.areatype_code,
    };
  });

  const validateOptions = dataValidated.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const index = areaTypeOptions.findIndex(
    (obj) => obj.value === formValues.area_type.value
  );

  const indexValidate = validateOptions.findIndex(
    (obj) => obj.value === formValues.validate.value
  );

  const handleChangeDismension = (e) => {
    const value = e.value;
    setFormValues({
      ...formValues,
      ["dimension_distance"]: {
        ...formValues["dimension_distance"],
        value,
      },
    });
  };
  const handleChangePosition = (e) => {
    const value = e.value;
    console.log(value, "value");
    setFormValues({
      ...formValues,
      ["posision_distance"]: {
        ...formValues["posision_distance"],
        value,
      },
    });
  };

  const handleChangeMaxWeight = (e) => {
    const value = e.value;
    setFormValues({
      ...formValues,
      ["max_weight_type"]: {
        ...formValues["max_weight_type"],
        value,
      },
    });
  };

  const handleChangeQty = (e) => {
    const value = e.value;
    setFormValues({
      ...formValues,
      ["max_qty_type"]: {
        ...formValues["max_qty_type"],
        value,
      },
    });
  };

  const handleChangeVolume = (e) => {
    const value = e.value;
    setFormValues({
      ...formValues,
      ["max_volume_type"]: {
        ...formValues["max_volume_type"],
        value,
      },
    });
  };

  const handleChangeAreaType = (e) => {
    const value = e.value;
    setFormValues({
      ...formValues,
      ["area_type"]: {
        ...formValues["area_type"],
        value,
      },
    });
  };

  const handleChangeValidate = (e, params) => {
    const value = params.value;
    console.log(value, "value");
    setFormValues({
      ...formValues,
      ["validate"]: {
        ...formValues["validate"],
        value,
      },
    });
  };

  const validatePostArea = (e) => {
    let isValid = true;

    const formFields = Object.keys(formArea);
    let newFormValues = { ...formArea };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formArea[currentField].value;
      const required = formArea[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormArea(newFormValues);

    return isValid;
  };

  const handleSaveArea = async () => {
    if (!validatePostArea()) {
      return;
    }

    const params = {
      pid: dataId.location_id,

      location_name: formArea.name.value,
      area_type: formArea.area_type.value,
      type: "area",
    };

    console.log(params, "params");

    try {
      const response = await dispatch(addLocation(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);

        await handleClear();
        await history.push(
          `/motor-pool/location-management/area/${response.payload.data.data.location_id}`
        );
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleChangeArea = (e) => {
    const { name, value } = e.target;
    setFormArea({
      ...formArea,
      [name]: {
        ...formArea[name],
        value,
      },
    });
  };

  const handleClear = () => {
    setFormValues({
      location_name: {
        value: "",
        error: false,
        required: "Y",
      },
      motorpool_area: {
        value: "",
        error: false,
        required: "N",
      },
      motorpool_area_name: {
        value: "",
        error: false,
        required: "N",
      },
      parent_area: {
        value: "",
        error: false,
        required: "Y",
      },
      parent_area_name: {
        value: "",
        error: false,
        required: "N",
      },
      area_type: {
        value: "",
        error: false,
        required: "N",
      },
      area_type_name: {
        value: "",
        error: false,
        required: "N",
      },
      product_id: {
        value: "",
        error: false,
        required: "N",
      },
      product_name: {
        value: "",
        error: false,
        required: "N",
      },
      model_id: {
        value: "",
        error: false,
        required: "N",
      },
      model_name: {
        value: "",
        error: false,
        required: "N",
      },
      color_id: {
        value: "",
        error: false,
        required: "N",
      },
      color_name: {
        value: "",
        error: false,
        required: "N",
      },
      x: {
        value: "",
        error: false,
        required: "N",
      },
      y: {
        value: "",
        error: false,
        required: "N",
      },
      z: {
        value: "",
        error: false,
        required: "N",
      },
      posision_distance: {
        value: "",
        error: false,
        required: "N",
      },
      l: {
        value: "",
        error: false,
        required: "N",
      },
      w: {
        value: "",
        error: false,
        required: "N",
      },
      h: {
        value: "",
        error: false,
        required: "N",
      },
      dimension_distance: {
        value: "",
        error: false,
        required: "N",
      },
      max_weight: {
        value: "",
        error: false,
        required: "N",
      },
      max_weight_type: {
        value: "",
        error: false,
        required: "N",
      },
      max_qty: {
        value: "",
        error: false,
        required: "N",
      },
      max_qty_type: {
        value: "",
        error: false,
        required: "N",
      },
      max_volume: {
        value: "",
        error: false,
        required: "N",
      },
      max_volume_type: {
        value: "",
        error: false,
        required: "N",
      },
      validate: {
        value: "",
        error: false,
        required: "N",
      },
      is_enable: {
        value: "",
        error: false,
        required: "N",
      },
    });

    setFormArea({
      ...formArea,
      name: {
        value: "",
        error: false,
        required: "Y",
      },
      area_type: {
        value: "",
        error: false,
        required: "N",
      },
      area_type_name: {
        value: "",
        error: false,
        required: "N",
      },
    });
    setShow(false);
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      {dataId && (
        <Card>
          <CardBody>
            <ThemeProvider theme={formLabelsTheme}>
              {/* header */}
              <div
                className="d-flex justify-content-between mb-6
   "
              >
                <p className=" font-size-h3 text-title-primary font-weight-boldest">
                  {/* Area : {dataId.location_name} */}
                </p>
                <Button
                  className="my-btn-primary-dark d-flex justify-content-end"
                  onClick={() => setShow(true)}
                >
                  Create Child Area
                </Button>
              </div>
              {/* form area */}
              <div>
                <Row>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <RedditTextField
                      required
                      label="Name"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      name="location_name"
                      value={formValues.location_name.value}
                      onChange={handleChange}
                      error={formValues.location_name.error}
                      helperText={
                        formValues.location_name.error ? (
                          <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                            {iconError} {"This field is required"}
                          </FormHelperText>
                        ) : (
                          ""
                        )
                      }
                    />
                    <RedditTextField
                      required
                      label="Motor pool Area"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      name="motorpool_area"
                      value={formValues.motorpool_area_name.value}
                      onChange={handleChange}
                      error={formValues.motorpool_area.error}
                      helperText={
                        formValues.motorpool_area.error ? (
                          <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                            {iconError} {"This field is required"}
                          </FormHelperText>
                        ) : (
                          ""
                        )
                      }
                      disabled
                    />
                  </Col>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          required
                          label="Parent Area"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          readOnly
                          name="parent_area"
                          value={formValues.parent_area_name.value}
                          error={formValues.parent_area.error}
                          helperText={
                            formValues.parent_area.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                      </Col>
                      <Col xs={1} sm={1} md={1} lg={1}>
                        <div>
                          <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                            <span
                              className="svg-icon svg-icon-md svg-icon-light"
                              onClick={() => setShowParent(true)}
                            >
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/Search.svg"
                                )}
                              />
                            </span>
                          </a>
                        </div>
                      </Col>
                      {formValues.parent_area_name.value !== "" && (
                        <Col xs={1} sm={1} md={1} lg={1}>
                          <div
                            style={{ marginTop: "22px", cursor: "pointer" }}
                            onClick={() => {
                              setFormValues({
                                ...formValues,
                                ["parent_area_name"]: {
                                  ...formValues["parent_area_name"],
                                  value: "",
                                },
                                ["parent_area"]: {
                                  ...formValues["parent_area"],
                                  value: "",
                                },
                              });
                            }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/x-square.svg"
                                )}
                              />
                            </span>
                          </div>
                        </Col>
                      )}
                    </Row>

                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          label="Area type"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          name="area_type"
                          readOnly
                          value={formValues.area_type_name.value}
                          error={formValues.area_type.error}
                          helperText={
                            formValues.area_type.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                      </Col>
                      <Col xs={1} sm={1} md={1} lg={1}>
                        <div>
                          <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                            <span
                              className="svg-icon svg-icon-md svg-icon-light"
                              onClick={() => setShowArea(true)}
                            >
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/Search.svg"
                                )}
                              />
                            </span>
                          </a>
                        </div>
                      </Col>
                      {formValues.area_type_name.value !== "" && (
                        <Col xs={1} sm={1} md={1} lg={1}>
                          <div
                            style={{ marginTop: "22px", cursor: "pointer" }}
                            onClick={() => {
                              setFormValues({
                                ...formValues,
                                ["area_type_name"]: {
                                  ...formValues["area_type_name"],
                                  value: "",
                                },
                                ["area_type"]: {
                                  ...formValues["area_type"],
                                  value: "",
                                },
                              });
                            }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/x-square.svg"
                                )}
                              />
                            </span>
                          </div>
                        </Col>
                      )}
                    </Row>

                    <Form.Check
                      inline
                      label="Enabled"
                      name="group1"
                      type="checkbox"
                      className="ml-5 mb-4 mt-4"
                      onChange={(e) => {
                        if (e.target.checked === true) {
                          setFormValues({
                            ...formValues,
                            ["is_enable"]: {
                              ...formValues["is_enable"],
                              value: "Y",
                            },
                          });
                        } else {
                          setFormValues({
                            ...formValues,
                            ["is_enable"]: {
                              ...formValues["is_enable"],
                              value: "N",
                            },
                          });
                        }
                      }}
                      checked={
                        formValues.is_enable.value === "Y" ? true : false
                      }
                    />
                  </Col>
                </Row>
              </div>
              <hr />
              {/* Storage */}

              <div>
                <p className="font-weight-boldest  m-3">Storage</p>

                <Row>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          label="Product"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          readOnly
                          value={formValues.product_name.value}
                          error={formValues.product_name.error}
                          helperText={
                            formValues.product_name.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                      </Col>
                      <Col xs={1} sm={1} md={1} lg={1}>
                        <div>
                          <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                            <span
                              className="svg-icon svg-icon-md svg-icon-light"
                              onClick={() => {
                                setGetDataProduct(true);
                                setShowProduct(true);
                              }}
                            >
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/Search.svg"
                                )}
                              />
                            </span>
                          </a>
                        </div>
                      </Col>
                      {formValues.product_name.value !== "" && (
                        <Col xs={1} sm={1} md={1} lg={1}>
                          <div
                            style={{ marginTop: "22px", cursor: "pointer" }}
                            onClick={() => {
                              setFormValues({
                                ...formValues,
                                ["product_name"]: {
                                  ...formValues["product_name"],
                                  value: "",
                                },
                                ["product_id"]: {
                                  ...formValues["product_id"],
                                  value: "",
                                },
                              });
                            }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/x-square.svg"
                                )}
                              />
                            </span>
                          </div>
                        </Col>
                      )}
                    </Row>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          label="Model"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          readOnly
                          value={formValues.model_name.value}
                          error={formValues.model_name.error}
                          helperText={
                            formValues.model_name.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                      </Col>
                      <Col xs={1} sm={1} md={1} lg={1}>
                        <div>
                          <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                            <span
                              className="svg-icon svg-icon-md svg-icon-light"
                              onClick={() => {
                                setGetDataModel(true);
                                setShowModel(true);
                              }}
                            >
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/Search.svg"
                                )}
                              />
                            </span>
                          </a>
                        </div>
                      </Col>
                      {formValues.model_name.value !== "" && (
                        <Col xs={1} sm={1} md={1} lg={1}>
                          <div
                            style={{ marginTop: "22px", cursor: "pointer" }}
                            onClick={() => {
                              setFormValues({
                                ...formValues,
                                ["model_name"]: {
                                  ...formValues["model_name"],
                                  value: "",
                                },
                                ["model_id"]: {
                                  ...formValues["model_id"],
                                  value: "",
                                },
                              });
                            }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/x-square.svg"
                                )}
                              />
                            </span>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </Col>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          label="Color"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          readOnly
                          value={formValues.color_name.value}
                          error={formValues.color_name.error}
                          helperText={
                            formValues.color_name.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                      </Col>
                      <Col xs={1} sm={1} md={1} lg={1}>
                        <div>
                          <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                            <span
                              className="svg-icon svg-icon-md svg-icon-light"
                              onClick={() => {
                                setGetDataColor(true);
                                setShowColor(true);
                              }}
                            >
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/Search.svg"
                                )}
                              />
                            </span>
                          </a>
                        </div>
                      </Col>
                      {formValues.color_name.value !== "" && (
                        <Col xs={1} sm={1} md={1} lg={1}>
                          <div
                            style={{ marginTop: "22px", cursor: "pointer" }}
                            onClick={() => {
                              setFormValues({
                                ...formValues,
                                ["color_name"]: {
                                  ...formValues["color_name"],
                                  value: "",
                                },
                                ["color_id"]: {
                                  ...formValues["color_id"],
                                  value: "",
                                },
                              });
                            }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/x-square.svg"
                                )}
                              />
                            </span>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Row>
              </div>
              <hr />
              {/* Position */}
              <div>
                <p className="font-weight-boldest m-3">Position</p>
                <Row>
                  <Col xs={12} sm={2} md={2} lg={2}>
                    <RedditTextField
                      label="X"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      type="number"
                      name="x"
                      value={formValues.x.value}
                      onChange={handleChange}
                    />
                  </Col>
                  <Col xs={12} sm={2} md={2} lg={2}>
                    <RedditTextField
                      label="Y"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      type="number"
                      name="y"
                      value={formValues.y.value}
                      onChange={handleChange}
                    />
                  </Col>
                  <Col xs={12} sm={2} md={2} lg={2}>
                    <RedditTextField
                      label="Z"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      type="number"
                      name="z"
                      value={formValues.z.value}
                      onChange={handleChange}
                    />
                  </Col>
                  <Col xs={12} sm={2} md={2} lg={2}>
                    <Select
                      options={distanceOptions}
                      value={getValueType(
                        formValues.posision_distance.value,
                        distanceOptions
                      )}
                      onChange={handleChangePosition}
                      className="mt-4 ml-3"
                    />
                  </Col>
                </Row>
              </div>
              <hr />
              {/* Dimension */}
              <div>
                <p className="font-weight-boldest m-3">Dimension</p>
                <Row>
                  <Col xs={12} sm={2} md={2} lg={2}>
                    <RedditTextField
                      label="L"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      type="number"
                      name="l"
                      value={formValues.l.value}
                      onChange={handleChange}
                    />
                  </Col>
                  <Col xs={12} sm={2} md={2} lg={2}>
                    <RedditTextField
                      label="W"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      type="number"
                      name="w"
                      value={formValues.w.value}
                      onChange={handleChange}
                    />
                  </Col>
                  <Col xs={12} sm={2} md={2} lg={2}>
                    <RedditTextField
                      label="H"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      type="number"
                      name="h"
                      value={formValues.h.value}
                      onChange={handleChange}
                    />
                  </Col>
                  <Col xs={12} sm={2} md={2} lg={2}>
                    <Select
                      options={distanceOptions}
                      value={getValueType(
                        formValues.dimension_distance.value,
                        distanceOptions
                      )}
                      onChange={handleChangeDismension}
                      className="mt-4 ml-3"
                    />
                  </Col>
                </Row>
              </div>
              <hr />
              {/* Capacity */}
              <div>
                <p className="font-weight-boldest m-3">Capacity</p>
                <Row>
                  <Col xs={12} sm={6} md={6} lg={6}>
                    <Row>
                      <Col md={8}>
                        <RedditTextField
                          label="Max Weight"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          type="number"
                          name="max_weight"
                          value={formValues.max_weight.value}
                          onChange={handleChange}
                        />
                      </Col>
                      <Col md={3}>
                        <Select
                          options={weightOptions}
                          value={getValueType(
                            formValues.max_weight_type.value,
                            weightOptions
                          )}
                          onChange={handleChangeMaxWeight}
                          className="mt-4 ml-3"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col md={8}>
                        <RedditTextField
                          label="Max Quantity"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          type="number"
                          name="max_qty"
                          value={formValues.max_qty.value}
                          onChange={handleChange}
                        />
                      </Col>
                      <Col md={3}>
                        <Select
                          options={uomOptions}
                          value={getValueType(
                            formValues.max_qty_type.value,
                            uomOptions
                          )}
                          onChange={handleChangeQty}
                          className="mt-4 ml-3"
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={12} sm={6} md={6} lg={6}>
                    <Row>
                      <Col md={8}>
                        <RedditTextField
                          label="Max Volume"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          type="number"
                          name="max_volume"
                          value={formValues.max_volume.value}
                          onChange={handleChange}
                        />
                      </Col>
                      <Col md={3}>
                        <Select
                          options={volumeOptions}
                          value={getValueType(
                            formValues.max_volume_type.value,
                            volumeOptions
                          )}
                          onChange={handleChangeVolume}
                          className="mt-4 ml-3"
                        />
                      </Col>
                    </Row>
                    <Autocomplete
                      disablePortal
                      name="validate"
                      options={validateOptions}
                      getOptionLabel={(option) => option.label.toString()}
                      disableClearable={true}
                      onChange={handleChangeValidate}
                      // value={validateOptions[indexValidate]}
                      value={
                        validateOptions.find(
                          (option) => option.value === formValues.validate.value
                        ) || null
                      }
                      renderInput={(params) => (
                        <RedditTextField
                          className={classes.margin}
                          {...params}
                          label="Validate By"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          name="validate"
                        />
                      )}
                    />
                  </Col>
                </Row>
              </div>
            </ThemeProvider>

            {/* handleSave */}
            <Row className="mt-6 justify-content-end">
              <Button variant="primary" onClick={handleSave}>
                Save
              </Button>
            </Row>
          </CardBody>
        </Card>
      )}

      <ModalProductSelect
        isOpen={showProduct}
        setShow={setShowProduct}
        setFormValues={setFormValues}
        formValues={formValues}
        setFields={setFieldsProduct}
        fields={fieldsProduct}
        getData={getDataProduct}
        setGetData={setGetDataProduct}
      />

      <ModalModelSelect
        isOpen={showModel}
        setShow={setShowModel}
        setFormValues={setFormValues}
        formValues={formValues}
        setFields={setFieldsModel}
        fields={fieldsModel}
        getData={getDataModel}
        setGetData={setGetDataModel}
      />

      <ModalColorSelect
        isOpen={showColor}
        setShow={setShowColor}
        setFormValues={setFormValues}
        formValues={formValues}
        setFields={setFieldsColor}
        fields={fieldsColor}
        getData={getDataColor}
        setGetData={setGetDataColor}
      />

      <ModalAreaSelect
        isOpen={showArea}
        setShow={setShowArea}
        setFormValues={setFormValues}
        formValues={formValues}
        setFields={setFieldsArea}
        fields={fieldsArea}
      />

      <ModalAreaSelect
        isOpen={showAreaChild}
        setShow={setShowAreaChild}
        setFormValues={setFormArea}
        formValues={formArea}
        setFields={setFieldsArea}
        fields={fieldsArea}
      />

      <ModalParentSelect
        isOpen={showParent}
        setShow={setShowParent}
        setFormValues={setFormValues}
        formValues={formValues}
        setFields={setFieldsParent}
        fields={fieldsParent}
      />

      {/* Modal Create */}
      {dataId && (
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={show}
          onHide={handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter text-white">
              Create New Child Area
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ThemeProvider theme={formLabelsTheme}>
              <div>
                <Row>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <RedditTextField
                      required
                      label="Parent Area"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      name="name"
                      disabled
                      value={dataId.location_name}
                    />
                    <RedditTextField
                      required
                      label="Motor pool Area"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      name="product_length"
                      value={dataId.motor_pool_name}
                      disabled
                    />
                  </Col>

                  <Col xs={12} sm={3} md={6} lg={6}>
                    <RedditTextField
                      required
                      label="Name"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      name="name"
                      value={formArea.name.value}
                      onChange={handleChangeArea}
                      error={formArea.name.error}
                      helperText={
                        formArea.name.error ? (
                          <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                            {iconError} {"This field is required"}
                          </FormHelperText>
                        ) : (
                          ""
                        )
                      }
                    />
                    <Row>
                      <Col xs={10} sm={3} md={9} lg={9}>
                        <RedditTextField
                          label="Area Type"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          name="area_type"
                          readOnly
                          value={formArea.area_type_name.value}
                          error={formArea.area_type.error}
                          helperText={
                            formArea.area_type.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                      </Col>
                      <Col>
                        <div>
                          <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                            <span
                              className="svg-icon svg-icon-md svg-icon-light"
                              onClick={() => setShowAreaChild(true)}
                            >
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/Search.svg"
                                )}
                              />
                            </span>
                          </a>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </ThemeProvider>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSaveArea}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};
